import { isEmpty } from 'lodash';

import { PUBLICATION_YEAR_FIELDS_MAP } from '@app/components';
import { DateRange } from '@app/utils';

export const getPublicationYearCQL = (
  publicationYear: DateRange | undefined
) => {
  if (!publicationYear || isEmpty(publicationYear)) {
    return '';
  }

  const { minDate, maxDate } = publicationYear;

  const minDateOperator =
    minDate && `${PUBLICATION_YEAR_FIELDS_MAP.publicationYearMin}${minDate}`;
  const maxDateOperator =
    maxDate && `${PUBLICATION_YEAR_FIELDS_MAP.publicationYearMax}${maxDate}`;

  if (minDate && maxDate) {
    return `${minDateOperator} AND ${maxDateOperator}`;
  }

  return minDateOperator || maxDateOperator || '';
};
